'use es6';

import { List } from 'immutable';
import { parse } from 'hub-http/helpers/params'; // Transforms mapping to internal param key => displayed param name in query

export const getQueryParamNames = paramsMap => {
  const result = {};
  Object.keys(paramsMap).forEach(key => {
    result[key] = paramsMap[key].param;
  });
  return result;
};
export const makeParamsGetter = (paramsMap, paramValueSanitizer, useStateNames = true) => (search = '') => {
  const state = {};
  const query = parse(search.replace('?', ''));
  Object.keys(paramsMap).forEach(paramKey => {
    const paramData = paramsMap[paramKey];
    const {
      param
    } = paramData;
    const val = query[param];

    if (val) {
      const sanitizedVal = paramValueSanitizer(param, val);

      if (useStateNames) {
        const {
          stateName
        } = paramData;

        if (stateName) {
          state[stateName] = sanitizedVal;
        }
      } else {
        state[param] = sanitizedVal;
      }
    }
  });
  return state;
};
export const makeDefaultParamsChecker = defaultValues => query => {
  const params = Object.keys(defaultValues);
  let includes = true;

  for (const param of params) {
    if (query[param] === undefined || query[param] === null) {
      includes = false;
      break;
    }
  }

  return includes;
};
export const tryBaseSanitizers = (param, val, ...sanitizers) => {
  let finalVal = val;

  for (const sanitizer of sanitizers) {
    const result = sanitizer(param, val);

    if (result !== val) {
      finalVal = result;
      break;
    }
  }

  return finalVal;
};
export const findInvalidParamValues = (query, allParamNames, validValues) => {
  const allParamNamesArray = Object.keys(allParamNames).map(p => allParamNames[p]);
  return Object.keys(query).reduce((paramsWithInvalidValues, param) => {
    // We want to strip out unsupported param names, so mark these as invalid
    if (!allParamNamesArray.includes(param)) {
      return paramsWithInvalidValues.push(param);
    }

    const value = query[param];
    const validator = validValues[param];

    if (typeof validator === 'function') {
      if (!validator(value)) {
        return paramsWithInvalidValues.push(param);
      }
    } else if (Array.isArray(validator)) {
      if (!validator.includes(value)) {
        return paramsWithInvalidValues.push(param);
      }
    }

    return paramsWithInvalidValues;
  }, new List());
};
export const correctInvalidParamValues = (query, paramsWithInvalidValues, defaultValues) => {
  const correctedQuery = query;
  paramsWithInvalidValues.forEach(param => {
    const defaultValue = defaultValues[param];

    if (defaultValue) {
      correctedQuery[param] = defaultValue;
    }

    delete correctedQuery[param];
  });
  return correctedQuery;
};
export const findAndCorrectInvalidParamValues = (query, allParamNames, validValues, defaultValues) => {
  const paramsWithInvalidValues = findInvalidParamValues(query, allParamNames, validValues);
  return correctInvalidParamValues(query, paramsWithInvalidValues, defaultValues);
};